<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Status" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-status-form [status]="status" *ngIf="status"></app-status-form>
        </form>
      </div>
    </section>
  </div>
</div>


